<template>
  <div>
    <b-row class="match-height">
      <b-col md="5">
        <b-card
          v-if="doctorateStat"
          class="card-transaction"
          no-body
        >
          <b-card-header>
            <b-card-title>{{ $t('Doctorate statistics') }}</b-card-title>
          </b-card-header>

          <b-card-body>
            <div
              v-for="(count, doctorate) in doctorateStat"
              :key="doctorate"
              class="transaction-item"
            >
              <b-media no-body>
                <b-media-aside>
                  <b-avatar
                    rounded
                    size="42"
                    variant="light-success"
                  >
                    <feather-icon
                      size="18"
                      icon="UserIcon"
                    />
                  </b-avatar>
                </b-media-aside>
                <b-media-body>
                  <h6 class="transaction-title">
                    {{ $t(`statistics.${doctorate}`) }}
                  </h6>
                  <small>{{ $t(`statistics.${doctorate}_text`) }}</small>
                </b-media-body>
              </b-media>
              <div
                class="font-weight-bolder text-primary"
              >
                {{ count }}
              </div>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col md="7">
        <b-row>
          <b-col>
            <b-card no-body>
              <org-count-by-type-and-org-admin-component />
            </b-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row>
      <b-col> <org-count-by-region-and-type-component /></b-col>
    </b-row>
    <b-row>
      <b-col> <count-by-apply-doc-researcher-region-component /></b-col>
    </b-row>
    <b-row>
      <b-col> <org-count-by-direction
        :items="countByDirection"
        :total="countByDirection.length"
      /></b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BCard, BCardHeader, BCardTitle,
  BCardBody, BMedia, BMediaAside, BAvatar, BMediaBody,
} from 'bootstrap-vue'
import { onUnmounted } from '@vue/composition-api'
import store from '@/store'
import statisticModule from '@/store/statistic'
import OrgCountByTypeAndOrgAdminComponent from './chart/OrgCountByTypeAndOrgAdminComponent.vue'
import OrgCountByRegionAndTypeComponent from './chart/OrgCountByRegionAndTypeComponent.vue'
import CountByApplyDocResearcherRegionComponent from './chart/CountByApplyDocResearcherRegionComponent.vue'
import OrgCountByDirection from './chart/CountByDirectionComponent.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
    OrgCountByTypeAndOrgAdminComponent,
    OrgCountByRegionAndTypeComponent,
    CountByApplyDocResearcherRegionComponent,
    OrgCountByDirection,
  },
  data() {
    return {
      color: ['light-primary', 'light-info', 'light-danger', 'light-success', 'light-warning'],
      icons: ['TrendingUpIcon', 'UserIcon', 'BoxIcon', 'DollarSignIcon'],
      countByDirection: [],
    }
  },
  computed: {
    doctorateStat() {
      return this.$store.state[this.MODULE_NAME].doctorateStat
    },
    orgCountByTypeAndOrgAdmin() {
      return this.$store.state[this.MODULE_NAME].orgCountByTypeAndOrgAdmin
    },
  },
  created() {
    this.$store.dispatch(`${this.MODULE_NAME}/doctorateStat`)
    this.$store.dispatch(`${this.MODULE_NAME}/orgCountByTypeAndOrgAdmin`)
    this.$store.dispatch(`${this.MODULE_NAME}/countByDirection`).then(({ data }) => {
      this.countByDirection = data
    })
  },
  setup() {
    const MODULE_NAME = 'statistic'
    // Register module
    if (!store.hasModule(MODULE_NAME)) store.registerModule(MODULE_NAME, statisticModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(MODULE_NAME)) store.unregisterModule(MODULE_NAME)
    })
    return {
      MODULE_NAME,
    }
  },
}
</script>

<style>

</style>
